import {useContext, useEffect} from 'react';
import {ParentMessageBusContext} from './ParentMessageBusProvider';
import {ParentMessageListenerFn} from '../../helpers/parentMessageBus';

export function useParentMessageHandler(
  handler: ParentMessageListenerFn,
): void {
  const {addListener, removeListener} = useContext(ParentMessageBusContext);
  useEffect(() => {
    addListener(handler);
    return () => removeListener(handler);
  }, [addListener, removeListener, handler]);
}
